import {Event} from "ts-typed-events";
import {TranslationChange} from "./models/TranslationChange";
import {translateFunction} from "./TranslationService";

const translate = translateFunction();

export function formatAdnRes(text: string | null): string {
	if (!text)
		return "";
	else if (text === "V1")
		return translate("adnres:v1");
	else if (text === "V2")
		return translate("adnres:v2");
	else if (text === "V3")
		return translate("adnres:v3");
	else
		return translate("Unknown");
}

export function formatOrderStatus(text: string | null): string {
	if (!text)
		return "";
	else if (text === "QUEUED")
		return translate("orderStatus:queued");
	else if (text === "PROCESSING")
		return translate("orderStatus:processing");
	else if (text === "QUEUED_FOR_SAVING")
		return translate("orderStatus:queuedForSaving");
	else if (text === "UNDER_REVIEW")
		return translate("orderStatus:underReview");
	else if (text === "ERROR")
		return translate("orderStatus:error");
	else if (text === "DONE")
		return translate("orderStatus:done");
	else
		return translate("Unknown");
}

export const LanguageEvents = {
	onChange: new Event<TranslationChange>(),
};
